<template>
  <div class="text-start">

    <nav class="border-b border-gray-300 px-2 md:px-0 py-2 mb-4" v-if="breadcrumb">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'vouchers'}">Vouchers</router-link>
            <span class="mx-2">/</span>
            <span>Generate vouchers</span>
          </div>
          <div class="text-xl">
            Generate vouchers
          </div>
        </div>
      </div>
    </nav>
    <div class="">
      <div class="">
        <div class="bg-white p-4 border rounded shadow-sm">
          <div class="">
            <label class="block text-sm">Voucher group name<span class="text-red-700">*</span></label>
            <input aria-label="Venue name" type="text" required v-model="name" :class="inputClass"
                   placeholder="Voucher group name"/>
          </div>
          <div class="flex my-3 justify-between">
            <div class="w-full mr-2">
              <!-- <label class="block text-sm leading-5">Value</label>
              <input aria-label="value" name="face_value" v-model="face_value" :class="inputClass"
                     placeholder="Voucher value"/> -->
            </div>   
            <!-- Removed Valid Till field -->
          </div>
          <div class="my-3">
            <label class="block text-sm leading-5">Service Plan</label>
            <select v-model="selectedServicePlan" :class="inputClass">
              <option v-for="plan in servicePlans" :key="plan.id" :value="plan.id">
                {{ plan.name }}
              </option>
            </select>
          </div>
          <div class="flex my-3 justify-between">
            <div class="w-full mr-2">
              <label class="block text-sm leading-5">Number of Vouchers</label>
              <input type="number" v-model="numberOfVouchers" :class="inputClass" min="1" max="20" @input="updatePreview"/>
            </div>
            <div class="w-full ml-2">
              <label class="block text-sm leading-5">Length Code</label>
              <input type="number" v-model.number="lengthCode" :class="inputClass" min="4" max="7" @input="updatePreview"/>
            </div>
          </div>
          <div class="my-3">
            <label class="block text-sm leading-5">Preview</label>
            <div class="bg-gray-100 p-2 rounded">{{ previewCode }}</div>
          </div>
          <div class="mt-6">
            <button type="submit" v-on:click="generateVouchers" class="rounded px-4 md:px-5 xl:px-4 py-2 bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight xl:text-base text-white">
              Generate Vouchers
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import Utils from "@/services/Utils";
//import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import axios from 'axios';

export default {
  name: "GenerateVouchers",
 // components: { DatePicker },
  data() {
    return {
      name: '',
      face_value: '',
      description: '',
      numberOfVouchers: 4,
      lengthCode: 4,
      previewCode: '',
      servicePlans: [],
      selectedServicePlan: '',
      loading: false,
      errors: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    };
  },
  props: {
    breadcrumb: { type: Boolean, default: true },
    voucherId: String,
  },
  mounted() {
    this.fetchServicePlans();
    this.$root.$on("venue_created", () => {
      this.$router.replace("/venues");
    });
  },
  methods: {
    fetchServicePlans() {
      const query = {
        query: `{
          servicePlansCount(limit: 10, offset: 0, order: "created_at desc", search: "")
          servicePlans(limit: 10, offset: 0, order: "created_at desc", search: "") {
            id
            name
            bandwidthPolicy {
              id
              name
            }
            description
            code
            time_limit
            time_limit_unit
            usage_limit
            usage_limit_unit
            simultaneous_connections
            validity
            validity_units
            price
          }
        }`
      };

      axios.post('https://api.expressdata.co.ke/graphql/', query)
        .then(response => {
          this.servicePlans = response.data.data.servicePlans;
        })
        .catch(error => {
          console.error("Error fetching service plans:", error);
        });
    },
    updatePreview() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < this.lengthCode; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.previewCode = `VV${result}`;
    },
    generateVouchers() {
      const vouchers = [];
      for (let i = 0; i < this.numberOfVouchers; i++) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
        for (let j = 0; j < this.lengthCode; j++) {
          result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        vouchers.push(`VV${result}`);
      }

      // Simulate saving vouchers and redirecting to the vouchers page
      console.log("Generated Vouchers:", vouchers);
      this.$router.push({ name: 'vouchers', params: { generatedVouchers: vouchers } });
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  watch: {
    lengthCode: "updatePreview",
    numberOfVouchers: "updatePreview"
  }
};
</script>

<style scoped>
.mx-datepicker {
  width: 100% !important;
}
</style>